import React, { useRef, useEffect, useState } from 'react'
import { Pressable, ViewStyle, Platform } from 'react-native'

interface HoverableItemProps {
  children: React.ReactNode
  onPress?: () => void
  onPressing?: (isPressed: boolean) => void
  onHover?: (isHovered: boolean) => void
  disabled?: boolean
}

export const HoverableItem: React.FC<HoverableItemProps> = ({
  children,
  onPress,
  onPressing,
  onHover,
  disabled = false,
}) => {
  const pressableRef = useRef<any>(null)

  useEffect(() => {
    if (Platform.OS === 'web' && pressableRef.current) {
      const element = pressableRef.current

      const handleMouseEnter = () => {
        if (!disabled) {
          onHover?.(true)
        }
      }

      const handleMouseLeave = () => {
        onHover?.(false)
      }

      // Add DOM event listeners for true hover on web
      element.addEventListener('mouseenter', handleMouseEnter)
      element.addEventListener('mouseleave', handleMouseLeave)

      return () => {
        element.removeEventListener('mouseenter', handleMouseEnter)
        element.removeEventListener('mouseleave', handleMouseLeave)
      }
    }
  }, [disabled])

  return (
    <Pressable
      ref={pressableRef}
      onPress={disabled ? undefined : onPress}
      onPressIn={() => !disabled && onPressing?.(true)}
      onPressOut={() => !disabled && onPressing?.(false)}
      disabled={disabled}
    >
      {children}
    </Pressable>
  )
}
